import { mathmlTagNames } from "mathml-tag-names";
import sanitize from "sanitize-html";
import { svgTagNames } from "svg-tag-names";

const explicitlyDisallowed = ["script", "style"];

export function sanitizeRichContent<TContent extends string | null | undefined>(
  content: TContent,
  shouldSanitize: boolean | undefined,
  isSanitized?: boolean,
): TContent {
  if (content == null || shouldSanitize !== true || isSanitized) {
    return content;
  }

  return sanitize(content, {
    allowedTags: sanitize.defaults.allowedTags
      .concat(
        ...mathmlTagNames,
        ...svgTagNames,
        "img",
        "video",
        "audio",
        "object",
      )
      .filter((tag) => !explicitlyDisallowed.includes(tag)),
    allowedSchemes: sanitize.defaults.allowedSchemes.concat("data"),
    allowedClasses: undefined,
    allowedAttributes: undefined,
  }) as TContent;
}
